import * as React from 'react';

const PlatterGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <g>
                <path fill="none" d="M0 0h144v144H0z" />
                <g>
                    <path
                        fill="#FFF"
                        d="M81.911 67.8l-8.419 8.4-11.226 11.2-14.032-14 1.403-8.4 4.21-8.4v-7l-1.403-4.2h8.419l1.403 4.2L63.67 58l5.612 2.8 7.017-7 4.21-8.4H94.54l-4.21 9.8z"
                    />
                    <path
                        fill="#FFF"
                        d="M55.25 100L35.605 80.4l9.823-9.8 19.645 19.6z"
                    />
                    <path
                        fill="#F6682F"
                        d="M29.993 88.8l16.838 16.8 7.015-7-16.839-16.798z"
                    />
                    <path
                        fill="#D2D6DF"
                        d="M109.976 39.8l-7.016 5.6H44.024l-7.016-5.6"
                    />
                    <path fill="#282C35" d="M31.395 41.2h84.192v-2.8H31.395z" />
                    <g fill="#282C35">
                        <path d="M103.452 46.8h-59.92l-7.4-5.906a1.396 1.396 0 01-.219-1.969 1.406 1.406 0 011.972-.218L44.516 44h57.952l6.63-5.293a1.408 1.408 0 011.975.218 1.4 1.4 0 01-.22 1.969l-7.401 5.906z" />
                        <path d="M62.266 88.638a1.236 1.236 0 01-.877-2.113l19.558-19.513 8.29-12.404 4.163-9.695c.27-.629.997-.919 1.63-.65.629.269.92.997.65 1.624l-4.318 9.999-8.574 12.789-19.645 19.6c-.241.242-.56.363-.877.363M48.235 74.8a1.4 1.4 0 01-1.385-1.631l1.531-8.795 4.063-8.104v-6.443l-1.332-3.984A1.4 1.4 0 0152 44.072a1.401 1.401 0 011.775.886l1.475 4.415v7.558l-4.264 8.507-1.368 8.192a1.402 1.402 0 01-1.383 1.17M69.12 62.284l-6.718-3.351-1.501-8.994-1.37-4.096a1.4 1.4 0 01.888-1.771 1.4 1.4 0 011.775.886l1.457 4.411 1.285 7.697 4.509 2.25 4.813-1.2 6.606-5.273 5.493-8.22c.429-.642 1.299-.819 1.946-.388.645.429.82 1.298.389 1.942l-5.904 8.717-7.256 5.79-6.413 1.6zM30.984 89.79L29 87.81l7.016-7L38 82.79zM47.823 106.59l-1.984-1.98 7.016-7 1.984 1.98z" />
                        <path d="M37.59 80.4l17.66 17.62 7.839-7.82-17.661-17.62-7.839 7.82zm17.66 21.58L33.621 80.4l11.807-11.78L67.057 90.2 55.25 101.98z" />
                        <path d="M56.653 91.6c-.359 0-.718-.137-.992-.41l-2.806-2.8a1.396 1.396 0 010-1.98 1.404 1.404 0 011.984 0l2.806 2.8a1.401 1.401 0 01-.992 2.39M69.282 62.2a1.401 1.401 0 01-.992-2.39l6.855-6.839 4.107-8.197a1.406 1.406 0 011.883-.627 1.4 1.4 0 01.63 1.88l-4.313 8.602-7.178 7.161c-.273.273-.632.41-.992.41" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

PlatterGraphicSvg.displayName = 'PlatterGraphicSvg';
export default PlatterGraphicSvg;
